import { PatientPortalEmailControllerApi } from "../../services";
import { getConfigObject, getXtenantId, useMutationWithLoading } from "../../utils/utils";

interface Params {
  emailUuids: string[];
  archiveStatus: boolean;
}

export const usePatientPortalEmailArchive = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientPortalEmailControllerApi(getConfigObject()).archivePatientPortalEmail(
      params.archiveStatus,
      params.emailUuids,
      getXtenantId()
    )
  );
